import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './password.types';

export const passwordSelectors = {
  ...generateResourceSelectors<types.IPassword>((state) => state.resource.password),
};
